import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Loader from "../../loader/loader";
import httpClient from "../../utils/httpClients";

function Terms_Conditions() {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const res = await httpClient.get(
          "/user/content/content-by-type/terms-and-conditions"
        );

        if (res.data.success) {
          if (res.data.data.content && res.data.data.content.length > 0) {
            setContent(res.data.data.content[0]);
          } else {
            setError("No content available");
          }
        } else {
          setError("Failed to load content: " + res.data.message);
        }
      } catch (err) {
        console.error("Error fetching content by type:", err);
        setError("An error occurred while loading content");
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  // Function to create HTML from description
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };

  return (
    <div className="terms-page">
      <div className="content-inner pb-0 container-fluid" id="page_layout">
        <div className="row row--grid">
          {/* breadcrumb */}
          <div className="col-12">
            <ul className="breadcrumb">
              <li className="breadcrumb__item">
                <Link to="/">Home</Link>
              </li>
              <li className="breadcrumb__item breadcrumb__item--active">
                {content?.title || "Terms & Conditions"}
              </li>
            </ul>
          </div>
          {/* end breadcrumb */}

          <div className="col-12">
            <div className="main__title">
              {loading ? (
                <Loader /> // Using your Loader component
              ) : error ? (
                <div className="error-message">
                  <p>{error}</p>
                </div>
              ) : content ? (
                <>
                  <h1>{content.title || "Terms & Conditions"}</h1>
                  {content.description ? (
                    // Check if description is HTML content
                    typeof content.description === "string" ? (
                      <div
                        className="terms-content"
                        dangerouslySetInnerHTML={createMarkup(
                          content.description
                        )}
                      />
                    ) : Array.isArray(content.description) ? (
                      // Handle case where it might be an array of HTML strings
                      content.description.map((paragraph, index) => (
                        <div
                          key={index}
                          className="terms-content"
                          dangerouslySetInnerHTML={createMarkup(paragraph)}
                        />
                      ))
                    ) : (
                      <p>No content available.</p>
                    )
                  ) : (
                    <p>No content available.</p>
                  )}
                </>
              ) : (
                <p>No content available.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms_Conditions;
